<template>
  <div>
    <v-row>
      <v-col md="12">
        <v-timeline dense>
          <v-slide-x-reverse-transition group>
            <v-timeline-item
              fill-dot
              small
              v-for="(step, index) in steps"
              :key="`step-${index}`">
              <v-card v-if="step.isNew || step.isEditing">
                <v-card-text>
                  <v-row>
                    <v-col md="6">
                      <v-img
                        v-if="src"
                        max-height="200"
                        max-width="300"
                        :src="src"
                      />
                      <v-card
                        v-else
                        flat
                        color="grey lighten-2"
                        width="300"
                        height="200">
                        <v-card-text>
                          El tamaño recomendado de la imagen es de 300px x 200px.
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col md="6">
                      <v-textarea
                        v-model="step.text"
                        hide-details
                        outlined
                        height="200"
                        rows="10"
                        no-resize
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col md="6">
                      <v-file-input
                        v-model="image"
                        clearable
                        accept=".jpg, .png"
                        @click:clear="clear"
                      />
                    </v-col>
                    <v-col md="6">
                      <v-btn
                        text
                        rounded
                        @click="cancel(index)">
                        Cancelar
                      </v-btn>
                      <v-btn
                        depressed
                        rounded
                        color="primary"
                        @click="save(index)">
                        Guardar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              <v-hover
                v-else
                v-slot="{ hover }">
                <v-card>
                  <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                  >
                    <v-toolbar-title>
                      Paso {{ index + 1 }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-menu
                      bottom
                      left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="primary"
                          v-bind="attrs"
                          v-on="on">
                          <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                      </template>

                      <v-list>
                        <v-list-item @click="edit(index, step)">
                          <v-list-item-icon>
                            <v-icon>mdi-pencil</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="remove(index)">
                          <v-list-item-icon>
                            <v-icon color="red">mdi-delete</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title class="red--text">Borrar</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-app-bar>
                  <v-card-text>
                    <v-row>
                      <v-col md="6">
                        <v-img
                          max-height="200"
                          max-width="300"
                          :src="step.img.location"
                        />
                      </v-col>
                      <v-col md="6">
                        <div
                          v-html="step.text"
                        />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions v-if="hover">
                    <v-btn
                      :disabled="addDisabled"
                      color="primary"
                      text
                      block
                      @click="addBelow(index)">
                      <v-icon>
                        mdi-plus
                      </v-icon>
                      Agregar paso debajo
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-timeline-item>
          </v-slide-x-reverse-transition>
          <v-timeline-item
            fill-dot
            class="white--text mb-12"
            color="grey"
            small>
            <v-btn
              :disabled="addDisabled"
              depressed
              rounded
              color="primary"
              @click="add">
              Agregar paso
            </v-btn>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import RecipeModel from '@/models/Recipe'

export default {
  props: {
    recipe: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    let recipeModel = new RecipeModel()

    return {
      recipeModel,
      steps: [],
      image: null,
      src: ''
    }
  },
  computed: {
    addDisabled () {
      return this.steps.some(step => step.isNew || step.isEditing)
    }
  },
  mounted () {
    const recipe = cloneDeep(this.recipe)
    if (recipe.steps.length > 0) this.steps = recipe.steps
    this.recipeModel = new RecipeModel(recipe)
  },
  watch: {
    recipe: async function (val) {
      if (val) {
        const recipe = cloneDeep(val)
        if (recipe.steps.length > 0) {
          this.steps = recipe.steps
        } else {
          this.steps = []
        }
        this.recipeModel = new RecipeModel(recipe)
      }
    },
    image (val) {
      if (val) {
        const reader = new FileReader()
        const vm = this
        reader.readAsDataURL(val)

        reader.onloadend = function () {
          vm.src = reader.result
        }
      }
    }
  },
  methods: {
    add () {
      this.clear()
      this.steps.push({
        img: '',
        text: '',
        isNew: true
      })
    },
    addBelow (index) {
      this.clear()
      this.steps.splice(index + 1, 0, {
        img: '',
        text: '',
        isNew: true
      })
    },
    cancel (index) {
      if (this.steps[index].isNew) {
        this.steps.splice(index, 1)
      } else {
        this.steps = this.steps.map(step => {
          step.isNew = false
          step.isEditing = false
          step.text = step.text.replaceAll('\n', '<br>')
          return step
        })
      }
    },
    async save (index) {
      const steps = cloneDeep(this.steps)

      steps[index].isEditing = false
      steps[index].isNew = false
      steps[index].img = this.src
      steps[index].text = steps[index].text.replaceAll('\n', '<br>')

      this.steps = steps
      try {
        const response = await this.$api.put(`/v1/recipes/${this.recipe._id}`, { steps: this.steps })
        this.steps = response.steps
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    clear () {
      this.src = ''
      this.image = null
    },
    async remove (index) {
      this.steps.splice(index, 1)
      try {
        const response = await this.$api.put(`/v1/recipes/${this.recipe._id}`, { steps: this.steps })
        this.steps = response.steps
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    edit (index) {
      const steps = cloneDeep(this.steps)

      steps[index].isEditing = true
      steps[index].text = steps[index].text.replaceAll('<br>', '\n')

      this.steps = steps
    }
  }
}
</script>
